const faqs = [
  {
    q: '哈哈影院需要注册才能观看吗？',
    a: '完全不需要注册！哈哈影院所有影视资源均免费开放，无需账号、无需登录，打开网站即可直接在线观看。我们致力于为每一位影迷提供无门槛的观影体验。',
  },
  {
    q: '播放时会出现卡顿或缓冲吗？',
    a: '哈哈影院采用智能 CDN 加速与多线路切换技术，确保播放流畅不卡顿。我们持续优化服务器带宽，即使高峰期也能保持稳定播放体验。如遇网络波动，可手动切换备用线路。',
  },
  {
    q: '支持哪些设备观看？',
    a: '哈哈影院全面适配电脑、平板和手机端，无论 Windows、macOS、iOS 还是 Android，打开浏览器即可畅享高清观影。推荐使用 Chrome 或 Safari 浏览器以获得最佳体验。',
  },
  {
    q: '资源更新频率如何？新片多久上线？',
    a: '我们保持每日同步更新，热门院线大片通常在网络版上线后 24 小时内即可在哈哈影院观看。电视剧和综艺遵循播出时间实时更新，确保您不错过任何精彩内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            常见问题
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-100 rounded-lg border border-background-200/60">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer text-foreground-800 font-medium text-sm md:text-base">
                <span className="pr-4">{faq.q}</span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-lg"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-foreground-500 text-sm leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}